import React, { createContext, useContext, useState } from 'react';

// Create context
const HeaderTitleContext = createContext();

// Create a provider component
export const HeaderTitleProvider = ({ children }) => {
  const [title, setTitle] = useState('');
  const [subtitle, setSubtitle] = useState('');

  return (
    <HeaderTitleContext.Provider value={{ title, subtitle, setTitle, setSubtitle }}>
      {children}
    </HeaderTitleContext.Provider>
  );
};

// Custom hook to use the header title context
export const useHeaderTitle = () => {
  const context = useContext(HeaderTitleContext);
  if (!context) {
    throw new Error('useHeaderTitle must be used within a HeaderTitleProvider');
  }
  return context;
};
